import S, { DataSignal } from 's-js';
import { IAjax } from 'lib/Ajax';
import { AutoSavingDraftObject } from 'lib/autoSave';
import { CachedModelLoader } from 'lib/CachedModelLoader';
import { ValidationWatcher } from 'lib/validationWatcher';

import { PCCache } from 'data/PCCache';

import { ConfigureReminders as ServerConfigureReminders, ConfigureRemindersOptions, DefaultReminders } from 'data/models/ConfigureReminders';
import { Organization, OrganizationOptions } from 'data/models/Organization';

export interface ConfigureRemindersParams {
    id : number;
}

export function ConfigureReminders(
    loader : CachedModelLoader<ServerConfigureReminders, ConfigureRemindersOptions>,
    ajax : IAjax,
    data : PCCache,
    { id } : ConfigureRemindersParams
) {
    const { model } = loader({ OrganizationId: id }, 30),
        org = data.Organizations.update1(null, { Id: id }),
        client = ajax.Url<Organization, OrganizationOptions>(() => org.Url() || ''),
        draft = AutoSavingDraftObject(org, client),
        validation = ValidationWatcher(client),
        firstReminderDirty = S.data(false),
        finalReminderDirty = S.data(false);

    return {
        Model: model,
        Organization: org,
        Validation: validation,
        FirstReminderWindow: reminderWithDefault(draft.FirstReminderWindow, model.DefaultReminders.DefaultFirstReminderWindow, firstReminderDirty),
        FinalReminderWindow: reminderWithDefault(draft.FinalReminderWindow, model.DefaultReminders.DefaultFinalReminderWindow, finalReminderDirty),
        FirstReminderDirty: firstReminderDirty,
        FinalReminderDirty: finalReminderDirty
    };
}
export type ConfigureReminders = ReturnType<typeof ConfigureReminders>;

function reminderWithDefault(
    reminderWindow : DataSignal<number | null>,
    defaultReminderWindow : () => number,
    reminderDirty : DataSignal<boolean>
) : DataSignal<number | null> {
    return (val? : number | null) => {
        if (val === undefined) return reminderWindow() !== null || reminderDirty() ?
            reminderWindow()
          : defaultReminderWindow();
        S.freeze(() => {
            reminderDirty(true);
            reminderWindow(val);
        });
        return val;
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/configurereminders/model.ts